import { render, staticRenderFns } from "./ChrisWillow.vue?vue&type=template&id=4b033840&"
import script from "./ChrisWillow.vue?vue&type=script&lang=js&"
export * from "./ChrisWillow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports